<div id="content-section">
  <div id="content-main" class="responsive-content-main" [ngStyle]="{ 'margin-right': sidebarMaximized ? '370px' : '270px' }">
    <div id="content-sidebar" [ngClass]="{ 'responsive-content-sidebar': sidebarOpen, 'hide-responsive-sidebar': !sidebarOpen }" [ngStyle]="{ width: sidebarMaximized ? '350px' : '250px' }" style="position: fixed; right: 20px">
      <div class="sticky-top">
        <small class="bg-white">
          <a href="#" class="d-none d-md-inline" [title]="sidebarMaximized ? 'Minimize Sidebar' : 'Maximize Sidebar'" (click)="sidebarMaximized = !sidebarMaximized; $event.preventDefault()">
            <i class="fas" [ngClass]="{ 'fa-arrow-left': !sidebarMaximized, 'fa-arrow-right': sidebarMaximized }"></i>
          </a>
        </small>
      </div>
      <a routerLink="/doc_templates/new" class="btn btn-primary btn-sm" style="width: 100%">
        <i class="fas fa-plus-circle"></i>
        &nbsp;New Template
      </a>
      <hr class="my-1" />
      <div class="clearfix"></div>
      <div class="text-center pagination-small-margin pagination-center">
        <pagination [boundaryLinks]="true" [totalItems]="count" (pageChanged)="pageChanged($event)" class="pagination-sm" [itemsPerPage]="searchParams.per_page" [maxSize]="3" previousText="&lsaquo;" nextText="&rsaquo;" firstText="&laquo;" lastText="&raquo;"></pagination>
      </div>
      <div class="text-center pt-1">
        <app-pagination-count
          [count]="count"
          singularName="Template"
          pluralName="Templates"
        ></app-pagination-count>
      </div>
      <hr class="my-1" />
      <div class="clearfix"></div>
      <div class="sticky-top bg-white">
        <h5 class="pt-2">
          <div class="pull-right float-right">
            <app-clear-search-btn [searching]="searching" (onClick)="clearSearch()"></app-clear-search-btn>
          </div>
          <span>
            Search&nbsp;&nbsp;
            <a href="javascript: void(0)" title="Search" style="cursor: pointer" (click)="!searching ? (searchParams.page = 1) && search() : ''"><i *ngIf="!searching" class="fas fa-arrow-circle-right"></i><i *ngIf="searching" class="fas fa-spinner fa-pulse fa-fw"></i></a>
          </span>
        </h5>
        <hr class="my-1" />
      </div>
      <div class="row">
        <div class="col-md-12" id="search-form" style="border-bottom: 1px solid #ccc">
          <div class="form-group mt-3">
            <label>Name</label>
            <input type="text" class="form-control" name="name" (keyup.enter)="search()" [(ngModel)]="searchParams.name" />
          </div>
          <div class="form-group">
            <label class="col-form-label">Templates from</label>
            <div>
              <div class="custom-control custom-radio" (click)="searchParams.v4_templates = false">
                <input [checked]="searchParams.v4_templates == false" type="radio" name="v4_templates" class="custom-control-input" value="false" />
                <label class="custom-control-label">V1 Templates</label>
              </div>
              <div class="custom-control custom-radio" (click)="searchParams.v4_templates = true">
                <input [checked]="searchParams.v4_templates == true" type="radio" name="v4_templates" class="custom-control-input" value="true" />
                <label class="custom-control-label">V5 Templates</label>
              </div>
            </div>
          </div>
          <div class="form-group" *ngIf="searchParams.v4_templates">
            <div class="custom-control custom-checkbox" (click)="searchParams.is_global = !searchParams.is_global">
              <input [checked]="searchParams.is_global" type="checkbox" class="custom-control-input" [(ngModel)]="searchParams.is_global" />
              <label class="custom-control-label">Include global templates</label>
            </div>
          </div>
          <div class="form-group">
            <app-document-type-search (clearDocumentType)="searchParams.document_type_id = undefined" (document_type_id)="searchParams.document_type_id = $event"></app-document-type-search>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox" (click)="searchParams.require_envelope = !searchParams.require_envelope; searchParams.require_envelope ? searchParams.require_envelope : (searchParams.require_envelope = undefined)">
              <input type="checkbox" class="custom-control-input" name="require_envelope" [checked]="searchParams.require_envelope" />
              <label class="custom-control-label">Require Envelope</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="searchParams.require_proof = !searchParams.require_proof; searchParams.require_proof ? searchParams.require_proof : (searchParams.require_proof = undefined)">
              <input type="checkbox" class="custom-control-input" name="require_proof" [checked]="searchParams.require_proof" />
              <label class="custom-control-label">Require Proof</label>
            </div>
            <div class="custom-control custom-checkbox" (click)="searchParams.send_check = !searchParams.send_check; searchParams.send_check ? searchParams.send_check : (searchParams.send_check = undefined)">
              <input type="checkbox" class="custom-control-input" name="send_check" [checked]="searchParams.send_check" />
              <label class="custom-control-label">Send Check</label>
            </div>
          </div>
          <div class="form-group">
            <button (click)="searchParams.page = 1; search()" class="btn btn-primary btn-sm" style="width: 100%" type="button" [disabled]="searching">
              Search
              <span *ngIf="searching">
                &nbsp;
                <i class="fas fa-spinner fa-fw fa-pulse"></i>
              </span>
            </button>
          </div>
        </div>
      </div>
    </div>
    <div id="content-inner" class="responsive-content-inner" style="padding: 0px 20px 10px 20px">
      <div class="container-shadow px-3 pb-4">
        <h2 class="pt-4 text-center">Document Templates</h2>
        <div class="table-responsive-md">
          <table class="table table-striped" *ngIf="count > 0">
            <thead>
              <tr>
                <th>Name</th>
                <th>Doc. Type</th>
                <th class="text-center">Parts</th>
                <th class="text-center">Documents</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let docTemplate of docTemplates">
                <td>
                  <a [routerLink]="'/doc_templates/' + docTemplate.id + '/edit'">{{ docTemplate.name }}</a>
                  <br />
                  <span *ngIf="docTemplate.require_envelope">
                    <app-badge badgeType="primary">
                      Requires Envelope
                    </app-badge>&nbsp;
                  </span>
                  <span *ngIf="docTemplate.send_check">
                    <app-badge badgeType="primary">
                      Sends Check
                    </app-badge>&nbsp;
                  </span>
                  <span *ngIf="docTemplate.is_letter">
                    <app-badge badgeType="info">
                      Letter
                    </app-badge>&nbsp;
                  </span>
                  <span *ngIf="docTemplate.is_global">
                    <app-badge badgeType="success">
                      Global
                    </app-badge>&nbsp;
                  </span>
                </td>
                <td>{{ docTemplate.document_type_prefix }}</td>
                <td class="text-center">{{ docTemplate.doc_parts_size }}</td>
                <td class="text-center">{{ docTemplate.documents_size }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</div>
<app-sidebar-toggle-btn [sidebarOpen]="sidebarOpen" (onClick)="sidebarOpen = !sidebarOpen"></app-sidebar-toggle-btn>
